import { useEffect } from "react";
import "./Microsoft365Pricing.css";
import { API_PRICETOOL_ROUTE } from "./Constants";
export default function Microsoft365Pricing(props) {
  const qparams =(
    new URLSearchParams(window.location.search)
  );
  const resellerId=qparams.get("reseller") || "1"
  var apiUrl = API_PRICETOOL_ROUTE +"?reseller="+resellerId
useEffect(() => {
    const iframe = document.getElementById('myIframe');

iframe.addEventListener('load', function () {
    if (iframe.contentWindow) {
        iframe.contentWindow.postMessage(props.isBlurred, '*');
    }
});
if (iframe.contentWindow) {
        iframe.contentWindow.postMessage(props.isBlurred, '*');
    }
}, [props.isBlurred]);


  return (
    <>
          <iframe id="myIframe" src={apiUrl} style={{width:'100%',height:'100%'}}></iframe>
    </>
  );
}
